module.exports = __webpack_public_path__ + "assets/img/reg-bottom.a84f999c.png";